/* bs-collection-grid — Custom element <bs-collection-grid> con 3 behaviors:
   1. Filter drawer mobile (toggle + ESC + overlay click + focus trap)
   2. Filter group collapse (gestionado nativo por <details>, JS solo sincroniza chevron)
   3. Sort dropdown change → submit sort_by query param
   4. Filter form submit → reconstruir URL con filter.v.X=Y (Shopify storefront filters)

   Patrón: custom element con guard contra doble init (Customizer recarga el script).
   Aislado en IIFE. */

(function () {
  'use strict';

  if (window.customElements && window.customElements.get('bs-collection-grid')) {
    return;
  }

  var FOCUSABLE_SELECTOR = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  // ============================================================
  // TRAMOS DE PRECIO — cálculo desde la distribución real
  // ============================================================
  var NICE_STEPS = [5, 10, 15, 20, 25, 30, 40, 50, 60, 75, 100, 125, 150, 200, 250, 300, 400, 500, 750, 1000, 1500, 2000, 3000, 5000, 10000, 20000, 50000];
  // Escalera GRUESA para la cola cara (grúas, sillas eléctricas): saltos que ~doblan.
  var COARSE_LADDER = [500, 1000, 2000, 5000, 10000, 20000, 50000];

  function niceStep(x) {
    for (var i = 0; i < NICE_STEPS.length; i++) {
      if (NICE_STEPS[i] >= x) return NICE_STEPS[i];
    }
    return Math.ceil(x / 1000) * 1000;
  }

  function countInRange(prices, a, c) {
    var count = 0;
    for (var k = 0; k < prices.length; k++) {
      if (prices[k] >= a && (c === Infinity || prices[k] < c)) count++;
    }
    return count;
  }

  // Genera tramos "A € – B €" desde TODOS los precios (euros), en DOS niveles:
  //   - Denso (fino, ~5 tramos) hasta el umbral T = redondeo del percentil 80 (donde está el grueso).
  //   - Cola cara (grueso, saltos que doblan: 500/1000/2000…) por encima de T, SOLO si el máximo la
  //     justifica (max > 2,5·T; ej. grúas de 2.000 € sobre productos de ~200 €). Último tramo "+X €".
  // Descarta los tramos SIN producto → nunca se muestra un rango vacío. [] si no hay distribución útil.
  function computePriceBuckets(pricesRaw) {
    var prices = pricesRaw.slice().sort(function (a, b) { return a - b; });
    var n = prices.length;
    if (n < 2) return [];
    var max = prices[n - 1];
    if (prices[0] === max) return [];

    var p80 = prices[Math.floor(0.8 * (n - 1))];
    var threshold = niceStep(Math.max(p80, 1));
    var hasTail = max > threshold * 2.5;

    var bounds = [];
    if (!hasTail) {
      // Sin cola cara: tramos finos uniformes hasta el máximo (~6).
      var fs = niceStep(max / 6);
      for (var b = fs; b < max; b += fs) bounds.push(b);
    } else {
      // Denso fino hasta T + cola gruesa por encima.
      var fs2 = niceStep(threshold / 5);
      for (var b2 = fs2; b2 < threshold; b2 += fs2) bounds.push(b2);
      bounds.push(threshold);
      for (var ci = 0; ci < COARSE_LADDER.length; ci++) {
        if (COARSE_LADDER[ci] > threshold && COARSE_LADDER[ci] < max) bounds.push(COARSE_LADDER[ci]);
      }
    }
    // Únicos, ordenados, estrictamente en (0, max).
    bounds = bounds.filter(function (v, ix, arr) {
      return v > 0 && v < max && arr.indexOf(v) === ix;
    }).sort(function (a, b) { return a - b; });

    var edges = [0].concat(bounds).concat([Infinity]);
    var out = [];
    for (var i = 0; i < edges.length - 1; i++) {
      var lower = edges[i];
      var upper = edges[i + 1];
      if (countInRange(prices, lower, upper) === 0) continue;
      if (upper === Infinity) {
        out.push({
          gte: lower === 0 ? '' : String(lower),
          lte: '',
          label: hasTail ? ('+' + lower + ' €') : (lower + ' € – ' + max + ' €')
        });
      } else {
        out.push({
          gte: lower === 0 ? '' : String(lower),
          lte: String(upper),
          label: lower + ' € – ' + upper + ' €'
        });
      }
    }
    return out.length >= 2 ? out : [];
  }

  // Lee TODOS los precios (por variante) de la colección vía /products.json (paginado).
  // Cachea el resultado en sessionStorage por handle → no re-descarga al navegar la misma colección.
  function fetchCollectionPrices(handle) {
    var cacheKey = 'bs-prices-' + handle;
    try {
      var cached = window.sessionStorage.getItem(cacheKey);
      if (cached) return Promise.resolve(JSON.parse(cached));
    } catch (e) { /* sessionStorage no disponible → seguir con fetch */ }

    var prices = [];
    function store(result) {
      try { window.sessionStorage.setItem(cacheKey, JSON.stringify(result)); } catch (e) { /* quota/priv → ignorar */ }
      return result;
    }
    function page(p) {
      return fetch('/collections/' + handle + '/products.json?limit=250&page=' + p, {
        headers: { 'Accept': 'application/json' }
      })
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (data) {
          var prods = (data && data.products) || [];
          for (var i = 0; i < prods.length; i++) {
            var vs = prods[i].variants || [];
            for (var j = 0; j < vs.length; j++) {
              var pr = parseFloat(vs[j].price);
              if (!isNaN(pr) && pr > 0) prices.push(pr);
            }
          }
          if (prods.length === 250 && p < 8) return page(p + 1);
          return store(prices);
        });
    }
    return page(1);
  }

  class BsCollectionGrid extends HTMLElement {
    constructor() {
      super();
      this._initialized = false;
      this._cleanup = [];
      this._lastFocused = null;
    }

    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;

      this.setupDrawer();
      this.setupSort();
      this.setupFilterForm();
      this.setupLoadMore();
      this.restoreLoadedPages();
      this.setupFilterGroupsAnimation();
      this.enhancePriceBuckets();
    }

    disconnectedCallback() {
      for (var i = 0; i < this._cleanup.length; i++) {
        try { this._cleanup[i](); } catch (e) { /* noop */ }
      }
      this._cleanup = [];
      this._initialized = false;
    }

    _addCleanup(fn) {
      this._cleanup.push(fn);
    }

    // ============================================================
    // PRECIO — reemplaza los tramos del server (basados en el máximo) por tramos FINOS calculados
    // desde la distribución real de precios (products.json), descartando los tramos sin producto.
    // Progressive enhancement: si el fetch falla, se quedan los tramos que pintó el server.
    // ============================================================
    enhancePriceBuckets() {
      var host = this;
      var groups = this.querySelectorAll('[data-bs-filter-group="filter.v.price"]');
      if (!groups.length || host._priceEnhanced) return;

      var m = window.location.pathname.match(/\/collections\/([^\/?#]+)/);
      if (!m) return;
      host._priceEnhanced = true;

      fetchCollectionPrices(m[1])
        .then(function (prices) {
          var buckets = computePriceBuckets(prices || []);
          if (!buckets.length) return;
          groups.forEach(function (group) { host._renderPriceBuckets(group, buckets); });
        })
        .catch(function () { /* silencioso: fallback a los tramos del server */ });
    }

    _renderPriceBuckets(group, buckets) {
      var ul = group.querySelector('.bs-filter-group__list');
      if (!ul) return;
      var existing = ul.querySelector('[data-bs-filter-price-range]');
      var gteName = existing ? existing.getAttribute('data-gte-name') : 'filter.v.price.gte';
      var lteName = existing ? existing.getAttribute('data-lte-name') : 'filter.v.price.lte';
      var params = new URLSearchParams(window.location.search);
      var curGte = params.get(gteName) || '';
      var curLte = params.get(lteName) || '';
      var groupId = group.getAttribute('data-bs-filter-group') || 'price';
      var checkSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';

      // Sin for/id: el label envuelve el input (asociación implícita) → toda la fila clicable,
      // incluido el texto. Con for/id fallaba en móvil por ids duplicados (form escritorio + móvil).
      var html = '';
      for (var i = 0; i < buckets.length; i++) {
        var b = buckets[i];
        var active = b.gte === curGte && b.lte === curLte;
        html += '<li class="bs-filter-group__item">'
          + '<label class="bs-filter-group__label">'
          + '<span class="bs-filter-group__check-wrap">'
          + '<input type="checkbox" class="bs-filter-group__input"'
          + (active ? ' checked' : '')
          + ' data-bs-filter-price-range data-gte="' + b.gte + '" data-lte="' + b.lte + '"'
          + ' data-gte-name="' + gteName + '" data-lte-name="' + lteName + '">'
          + '<span class="bs-filter-group__check" aria-hidden="true">' + checkSvg + '</span>'
          + '</span>'
          + '<span class="bs-filter-group__option-label">' + b.label + '</span>'
          + '</label></li>';
      }
      ul.innerHTML = html;
    }

    // ============================================================
    // 1. DRAWER
    // ============================================================
    setupDrawer() {
      var host = this;
      var trigger = this.querySelector('[data-bs-filter-trigger]');
      var drawer = this.querySelector('[data-bs-drawer]');
      var overlay = this.querySelector('[data-bs-drawer-overlay]');
      var closeBtn = this.querySelector('[data-bs-drawer-close]');
      var panel = this.querySelector('[data-bs-drawer-panel]');

      if (!trigger || !drawer || !panel) return;

      function open() {
        if (drawer.getAttribute('aria-hidden') === 'false') return;
        host._lastFocused = document.activeElement;
        drawer.setAttribute('aria-hidden', 'false');
        trigger.setAttribute('aria-expanded', 'true');
        document.documentElement.style.overflow = 'hidden';

        // Focus al primer interactive del panel.
        setTimeout(function () {
          var first = panel.querySelector(FOCUSABLE_SELECTOR);
          if (first) first.focus();
        }, 50);
      }

      function close() {
        if (drawer.getAttribute('aria-hidden') === 'true') return;
        drawer.setAttribute('aria-hidden', 'true');
        trigger.setAttribute('aria-expanded', 'false');
        document.documentElement.style.overflow = '';

        if (host._lastFocused && typeof host._lastFocused.focus === 'function') {
          host._lastFocused.focus();
        }
      }

      function onKeydown(e) {
        if (drawer.getAttribute('aria-hidden') !== 'false') return;

        if (e.key === 'Escape') {
          e.preventDefault();
          close();
          return;
        }

        // Focus trap.
        if (e.key === 'Tab') {
          var focusables = Array.prototype.slice.call(panel.querySelectorAll(FOCUSABLE_SELECTOR));
          if (focusables.length === 0) return;

          // Edge case: 1 solo focusable. Tab queda en el mismo elemento.
          if (focusables.length === 1) {
            e.preventDefault();
            focusables[0].focus();
            return;
          }

          var first = focusables[0];
          var last = focusables[focusables.length - 1];

          if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
          } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        }
      }

      trigger.addEventListener('click', open);
      if (closeBtn) closeBtn.addEventListener('click', close);
      if (overlay) overlay.addEventListener('click', close);
      document.addEventListener('keydown', onKeydown);

      this._addCleanup(function () {
        trigger.removeEventListener('click', open);
        if (closeBtn) closeBtn.removeEventListener('click', close);
        if (overlay) overlay.removeEventListener('click', close);
        document.removeEventListener('keydown', onKeydown);
        document.documentElement.style.overflow = '';
      });
    }

    // ============================================================
    // 2. SORT — dropdown custom con listbox a11y, keyboard nav.
    // ============================================================
    setupSort() {
      var sortRoot = this.querySelector('[data-bs-sort]');
      if (!sortRoot) return;
      var trigger = sortRoot.querySelector('[data-bs-sort-trigger]');
      var menu = sortRoot.querySelector('[data-bs-sort-menu]');
      var options = Array.prototype.slice.call(sortRoot.querySelectorAll('[data-bs-sort-option]'));
      if (!trigger || !menu || options.length === 0) return;

      function openMenu() {
        if (!menu.hasAttribute('hidden')) return;
        menu.removeAttribute('hidden');
        trigger.setAttribute('aria-expanded', 'true');
        // Foco al option seleccionado o al primero.
        var selected = sortRoot.querySelector('[aria-selected="true"]');
        (selected || options[0]).focus();
      }

      function closeMenu(returnFocus) {
        if (menu.hasAttribute('hidden')) return;
        menu.setAttribute('hidden', '');
        trigger.setAttribute('aria-expanded', 'false');
        if (returnFocus) trigger.focus();
      }

      function selectOption(option) {
        var value = option.getAttribute('data-value');
        if (!value) return;
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', value);
        url.searchParams.delete('page');

        // AJAX: refetch + replace grid + update URL, sin recargar página.
        var section = sortRoot.closest('bs-collection-grid');
        if (!section) {
          window.location.href = url.toString();
          return;
        }
        closeMenu(false);
        section.classList.add('bs-collection-grid--loading');

        fetch(url.toString(), { headers: { 'Accept': 'text/html' } })
          .then(function (res) { if (!res.ok) throw new Error('HTTP ' + res.status); return res.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var newSection = doc.querySelector('bs-collection-grid[data-section-id="' + section.dataset.sectionId + '"]') || doc.querySelector('bs-collection-grid');
            if (!newSection) throw new Error('Section not found.');

            // Reemplaza grid + counter + dropdown current label.
            var oldGrid = section.querySelector('[data-bs-grid-list]');
            var newGrid = newSection.querySelector('[data-bs-grid-list]');
            if (oldGrid && newGrid) oldGrid.replaceWith(newGrid);

            var oldCount = section.querySelector('.bs-collection-grid__count');
            var newCount = newSection.querySelector('.bs-collection-grid__count');
            if (oldCount && newCount) oldCount.replaceWith(newCount);

            // Actualiza el current text del trigger + estado aria-selected de las options.
            var currentEl = sortRoot.querySelector('[data-bs-sort-current]');
            if (currentEl) currentEl.textContent = option.textContent.trim();
            options.forEach(function (opt) {
              var isSel = opt === option;
              opt.setAttribute('aria-selected', String(isSel));
              opt.classList.toggle('bs-collection-grid__sort-option--selected', isSel);
            });

            window.history.pushState({}, '', url.toString());
            section.classList.remove('bs-collection-grid--loading');
          })
          .catch(function (err) {
            console.warn('[bs-collection-grid] Sort fetch failed:', err);
            window.location.href = url.toString();
          });
      }

      function onTriggerClick(e) {
        e.preventDefault();
        if (menu.hasAttribute('hidden')) openMenu();
        else closeMenu(true);
      }

      function onTriggerKey(e) {
        if (e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          openMenu();
        }
      }

      function onOptionClick(e) {
        e.preventDefault();
        selectOption(e.currentTarget);
      }

      function onMenuKey(e) {
        var active = document.activeElement;
        var idx = options.indexOf(active);
        if (e.key === 'Escape') {
          e.preventDefault();
          closeMenu(true);
        } else if (e.key === 'ArrowDown') {
          e.preventDefault();
          var next = options[(idx + 1) % options.length];
          next.focus();
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          var prev = options[(idx - 1 + options.length) % options.length];
          prev.focus();
        } else if (e.key === 'Home') {
          e.preventDefault();
          options[0].focus();
        } else if (e.key === 'End') {
          e.preventDefault();
          options[options.length - 1].focus();
        } else if (e.key === 'Enter' || e.key === ' ') {
          if (idx >= 0) {
            e.preventDefault();
            selectOption(active);
          }
        } else if (e.key === 'Tab') {
          // Cerrar al tabular fuera.
          closeMenu(false);
        }
      }

      function onDocClick(e) {
        if (menu.hasAttribute('hidden')) return;
        if (sortRoot.contains(e.target)) return;
        closeMenu(false);
      }

      trigger.addEventListener('click', onTriggerClick);
      trigger.addEventListener('keydown', onTriggerKey);
      menu.addEventListener('keydown', onMenuKey);
      options.forEach(function (opt) { opt.addEventListener('click', onOptionClick); });
      document.addEventListener('click', onDocClick);

      this._addCleanup(function () {
        trigger.removeEventListener('click', onTriggerClick);
        trigger.removeEventListener('keydown', onTriggerKey);
        menu.removeEventListener('keydown', onMenuKey);
        options.forEach(function (opt) { opt.removeEventListener('click', onOptionClick); });
        document.removeEventListener('click', onDocClick);
      });
    }

    // ============================================================
    // 3. FILTER FORM (storefront filters)
    // ============================================================
    setupFilterForm() {
      var host = this;
      var forms = this.querySelectorAll('[data-bs-filter-form], [data-bs-filter-form-desktop]');
      if (forms.length === 0) return;

      function buildFilteredUrl(form) {
        var url = new URL(window.location.href);
        var keysToDelete = [];
        url.searchParams.forEach(function (_v, k) {
          if (k.indexOf('filter.') === 0) keysToDelete.push(k);
        });
        keysToDelete.forEach(function (k) { url.searchParams.delete(k); });
        url.searchParams.delete('page');

        var inputs = form.querySelectorAll('[data-bs-filter-input]:checked');
        inputs.forEach(function (input) {
          url.searchParams.append(input.name, input.value);
        });

        // Filtro de precio (price_range) por TRAMOS: un solo [data-bs-filter-price-range] marcado.
        // Su data-gte/data-lte (euros) → filter.v.price.gte/.lte (nombres en data-gte-name/lte-name).
        // Vacío = sin ese límite (no se añade el param): "0 – X" solo pone lte; "X – max" solo gte.
        var priceRange = form.querySelector('[data-bs-filter-price-range]:checked');
        if (priceRange) {
          var gte = (priceRange.getAttribute('data-gte') || '').trim();
          var lte = (priceRange.getAttribute('data-lte') || '').trim();
          var gteName = priceRange.getAttribute('data-gte-name');
          var lteName = priceRange.getAttribute('data-lte-name');
          if (gte !== '' && gteName) url.searchParams.append(gteName, gte);
          if (lte !== '' && lteName) url.searchParams.append(lteName, lte);
        }
        return url;
      }

      function replaceNode(oldEl, newEl) {
        if (!oldEl || !newEl) return;
        oldEl.replaceWith(newEl);
      }

      function applyFiltersFromForm(form) {
        var url = buildFilteredUrl(form);
        var section = host;
        section.classList.add('bs-collection-grid--loading');

        fetch(url.toString(), { headers: { 'Accept': 'text/html' } })
          .then(function (res) {
            if (!res.ok) throw new Error('HTTP ' + res.status);
            return res.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var newSection = doc.querySelector('bs-collection-grid[data-section-id="' + section.dataset.sectionId + '"]');
            if (!newSection) {
              newSection = doc.querySelector('bs-collection-grid');
            }
            if (!newSection) throw new Error('Section not found in response.');

            // Reemplazar grid + pagination + counter + sidebar form (sin destruir el drawer abierto).
            replaceNode(section.querySelector('[data-bs-grid-list]'), newSection.querySelector('[data-bs-grid-list]'));

            var newEmpty = newSection.querySelector('.bs-collection-grid__empty');
            var oldEmpty = section.querySelector('.bs-collection-grid__empty');
            if (newEmpty && oldEmpty) {
              replaceNode(oldEmpty, newEmpty);
            } else if (newEmpty && !oldEmpty) {
              section.querySelector('.bs-collection-grid__content').appendChild(newEmpty);
            } else if (!newEmpty && oldEmpty) {
              oldEmpty.remove();
            }

            replaceNode(section.querySelector('.bs-collection-grid__count'), newSection.querySelector('.bs-collection-grid__count'));

            // Refrescar counts del sidebar desktop (los (N) cambian con filtros activos).
            var newSidebarForm = newSection.querySelector('[data-bs-filter-form-desktop]');
            var oldSidebarForm = section.querySelector('[data-bs-filter-form-desktop]');
            if (newSidebarForm && oldSidebarForm) {
              // Conservar el `<details open>` state — solo replace los counts.
              oldSidebarForm.querySelectorAll('.bs-filter-group__count').forEach(function (oldCount, idx) {
                var newCounts = newSidebarForm.querySelectorAll('.bs-filter-group__count');
                if (newCounts[idx]) oldCount.textContent = newCounts[idx].textContent;
              });
            }

            // Animar entrada de las primeras N cards visibles.
            var newCells = section.querySelectorAll('[data-bs-grid-list] .bs-collection-grid__cell');
            newCells.forEach(function (cell, idx) {
              cell.classList.add('bs-collection-grid__cell--entering');
              cell.style.animationDelay = (Math.min(idx, 8) * 30) + 'ms';
            });

            // Actualizar URL sin reload.
            window.history.pushState({}, '', url.toString());
            section.classList.remove('bs-collection-grid--loading');
          })
          .catch(function (err) {
            console.warn('[bs-collection-grid] Filter fetch failed:', err);
            // Fallback: navegación clásica.
            window.location.href = url.toString();
          });
      }

      forms.forEach(function (form) {
        var isDesktop = form.hasAttribute('data-bs-filter-form-desktop');
        var clearBtn = form.querySelector('[data-bs-filter-clear]');

        function onSubmit(e) {
          if (e) e.preventDefault();
          applyFiltersFromForm(form);
        }

        function onChange() {
          applyFiltersFromForm(form);
        }

        // Precio single-select: al marcar un tramo, desmarca los demás del mismo form. Se registra
        // ANTES que onChange para que en desktop applyFilters ya vea un único [checked]. En mobile
        // (aplica al pulsar el botón) da el mismo comportamiento visual de radio.
        function onPriceRangeChange(e) {
          var t = e.target;
          if (!t || !t.matches || !t.matches('[data-bs-filter-price-range]')) return;
          if (t.checked) {
            form.querySelectorAll('[data-bs-filter-price-range]').forEach(function (cb) {
              if (cb !== t) cb.checked = false;
            });
          }
        }

        function onClear(e) {
          if (e) e.preventDefault();
          form.querySelectorAll('[data-bs-filter-input]').forEach(function (input) { input.checked = false; });
          form.querySelectorAll('[data-bs-filter-price-range]').forEach(function (cb) { cb.checked = false; });
          if (isDesktop) applyFiltersFromForm(form);
        }

        form.addEventListener('submit', onSubmit);
        form.addEventListener('change', onPriceRangeChange);
        if (clearBtn) clearBtn.addEventListener('click', onClear);
        if (isDesktop) form.addEventListener('change', onChange);

        host._addCleanup(function () {
          form.removeEventListener('submit', onSubmit);
          form.removeEventListener('change', onPriceRangeChange);
          if (clearBtn) clearBtn.removeEventListener('click', onClear);
          if (isDesktop) form.removeEventListener('change', onChange);
        });
      });
    }

    // ============================================================
    // 4. LOAD MORE (AJAX append) — pattern SOKA sk-collection-grid.
    // El <a> mantiene href real (graceful degradation zero-JS + SEO),
    // pero el click se intercepta para fetch + parse + append in-place.
    // ============================================================
    setupLoadMore() {
      var host = this;

      // Event delegation: listener en el host. Sobrevive al replace del grid
      // tras filter/sort AJAX (los botones nuevos heredan el handler).
      function onHostClick(e) {
        var btn = e.target.closest('[data-bs-load-more]');
        if (!btn || !host.contains(btn)) return;
        var url = btn.getAttribute('href');
        if (!url || btn.dataset.loading === 'true') return;
        e.preventDefault();

        btn.dataset.loading = 'true';
        btn.setAttribute('aria-busy', 'true');
        var originalText = btn.textContent;
        btn.textContent = 'Cargando...';

        fetch(url, { headers: { 'Accept': 'text/html' } })
          .then(function (res) {
            if (!res.ok) throw new Error('HTTP ' + res.status);
            return res.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var newGrid = doc.querySelector('[data-bs-grid-list]');
            var newBtn = doc.querySelector('[data-bs-load-more]');
            var currentGrid = host.querySelector('[data-bs-grid-list]');
            var paginationLi = host.querySelector('[data-bs-pagination]');
            if (!newGrid || !currentGrid) {
              throw new Error('No se encontró el grid en la respuesta.');
            }

            // Extraer las cards nuevas (excluir el <li> de paginación si está dentro).
            var newCards = newGrid.querySelectorAll('.bs-collection-grid__cell');
            var firstNewCell = null;
            newCards.forEach(function (cell, idx) {
              cell.classList.add('bs-collection-grid__cell--entering');
              cell.style.animationDelay = (idx * 50) + 'ms';
              cell.removeAttribute('data-lcp');
              if (paginationLi) {
                currentGrid.insertBefore(cell, paginationLi);
              } else {
                currentGrid.appendChild(cell);
              }
              if (idx === 0) firstNewCell = cell;
            });

            if (firstNewCell) {
              var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
              var top = firstNewCell.getBoundingClientRect().top + window.pageYOffset - 80;
              window.scrollTo({
                top: top,
                behavior: prefersReduced ? 'auto' : 'smooth'
              });
            }

            // Sincronizar la URL del navegador con la página recién cargada (?page=N). `url` es
            // el href que tenía el botón antes del fetch (la página que se acaba de traer). Usamos
            // replaceState y no pushState: el "Cargar más" AÑADE productos a la lista, no navega
            // entre páginas, así que no queremos ensuciar el historial ni que "atrás" solo cambie
            // la URL dejando el contenido acumulado. Igual que sort/filter, pero con replaceState.
            try {
              window.history.replaceState({}, '', url);
              // Sincronizar el canonical (y og:url) con la página mostrada. Actualizamos SOLO el
              // parámetro ?page del canonical que emitió Shopify (conservando su lógica de
              // filtros/sort), para que no siga apuntando a la página anterior tras el load-more.
              var loadedPage = new URL(url, window.location.origin).searchParams.get('page');
              var canonical = document.querySelector('link[rel="canonical"]');
              if (canonical) {
                var cu = new URL(canonical.href);
                if (loadedPage) {
                  cu.searchParams.set('page', loadedPage);
                } else {
                  cu.searchParams.delete('page');
                }
                canonical.setAttribute('href', cu.href);
                var ogUrl = document.querySelector('meta[property="og:url"]');
                if (ogUrl) ogUrl.setAttribute('content', cu.href);
              }
            } catch (e) {
              /* replaceState/URL puede fallar en contextos raros (about:, sandbox); no es crítico. */
            }

            if (newBtn) {
              var nextUrl = newBtn.getAttribute('href');
              btn.setAttribute('href', nextUrl);
              btn.textContent = originalText;
              btn.dataset.loading = 'false';
              btn.removeAttribute('aria-busy');
            } else {
              if (paginationLi) {
                paginationLi.style.display = 'none';
              } else {
                btn.style.display = 'none';
              }
            }
          })
          .catch(function (err) {
            console.warn('[bs-collection-grid] Load more failed:', err);
            btn.textContent = originalText;
            btn.dataset.loading = 'false';
            btn.removeAttribute('aria-busy');
            window.location.href = url;
          });
      }

      host.addEventListener('click', onHostClick);
      this._addCleanup(function () {
        host.removeEventListener('click', onHostClick);
      });
    }

    // ============================================================
    // 4b. RESTAURAR PÁGINAS ACUMULADAS al cargar con ?page=N (N>1).
    // El "Cargar más" (setupLoadMore) sincroniza la URL a ?page=N. Si el usuario recarga o
    // comparte esa URL, Shopify solo renderiza la página N server-side. Aquí, en el navegador,
    // traemos las páginas 1..N-1 y las ANTEPONEMOS al contenido ya renderizado, de modo que se
    // vea la lista completa acumulada (1..N), como estaba antes de recargar. Los crawlers/no-JS
    // siguen viendo la página N limpia (bien para SEO: cada ?page=N es indexable con sus productos).
    // El botón "Cargar más" ya viene apuntando a la página N+1 (render server-side de la página N),
    // así que seguir cargando encadena bien. La página 1 es la única que trae la card de newsletter,
    // por eso al anteponerla la card cae en su posición sin duplicarse.
    // ============================================================
    restoreLoadedPages() {
      var host = this;
      var params = new URLSearchParams(window.location.search);
      var currentPage = parseInt(params.get('page'), 10);
      if (!currentPage || currentPage < 2) return;

      var grid = host.querySelector('[data-bs-grid-list]');
      if (!grid) return;

      host.classList.add('bs-collection-grid--loading');

      // URLs de las páginas 1..currentPage-1, conservando filtros/orden actuales de la URL.
      var requests = [];
      for (var p = 1; p < currentPage; p++) {
        var u = new URL(window.location.href);
        if (p === 1) {
          u.searchParams.delete('page');
        } else {
          u.searchParams.set('page', String(p));
        }
        requests.push(
          fetch(u.toString(), { headers: { 'Accept': 'text/html' } }).then(function (res) {
            if (!res.ok) throw new Error('HTTP ' + res.status);
            return res.text();
          })
        );
      }

      Promise.all(requests)
        .then(function (htmls) {
          // Promise.all conserva el orden del array → página 1, 2, ... → cells en orden correcto.
          var frag = document.createDocumentFragment();
          htmls.forEach(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var g = doc.querySelector('[data-bs-grid-list]');
            if (!g) return;
            // Solo las celdas de producto/newsletter; el <li> de paginación (.bs-collection-grid__pagination)
            // NO matchea .bs-collection-grid__cell, así que no se cuela ningún botón intermedio.
            g.querySelectorAll('.bs-collection-grid__cell').forEach(function (cell) {
              cell.removeAttribute('data-lcp');
              frag.appendChild(cell);
            });
          });
          // Anteponer las páginas previas ANTES del contenido de la página N ya renderizado.
          grid.insertBefore(frag, grid.firstChild);
          host.classList.remove('bs-collection-grid--loading');
        })
        .catch(function (err) {
          console.warn('[bs-collection-grid] Restaurar páginas acumuladas falló:', err);
          host.classList.remove('bs-collection-grid--loading');
        });
    }

    // ============================================================
    // 5. ANIMACIÓN expand/collapse del <details> de los filter groups.
    // El nativo <details> abre/cierra instantáneo. Interceptamos el click del
    // <summary> y animamos la altura del contenido con CSS transition.
    // Usa event delegation para que sobreviva al replace AJAX del sidebar.
    // ============================================================
    setupFilterGroupsAnimation() {
      var host = this;

      // Altura objetivo de la animación TOPADA al max-height del CSS (listas largas con scroll):
      // scrollHeight devuelve la altura COMPLETA (ignora max-height), así que sin este tope la
      // animación apunta más allá de la caja recortada y el colapso se descuadra.
      function animTargetHeight(el) {
        var full = el.scrollHeight;
        var maxH = parseFloat(getComputedStyle(el).maxHeight);
        return (!isNaN(maxH) && maxH > 0 && full > maxH) ? maxH : full;
      }

      function onClick(e) {
        var summary = e.target.closest('.bs-filter-group__summary');
        if (!summary || !host.contains(summary)) return;
        var details = summary.parentElement;
        if (!details || !details.matches('.bs-filter-group')) return;
        var content = details.querySelector('.bs-filter-group__list, .bs-filter-group__empty');
        if (!content) return;

        // Si ya hay una animación en curso, dejar que termine.
        if (details.dataset.animating === 'true') {
          e.preventDefault();
          return;
        }

        e.preventDefault();

        var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (prefersReduced) {
          details.toggleAttribute('open');
          return;
        }

        details.dataset.animating = 'true';
        var willOpen = !details.open;

        // finish(): idempotente. Limpia estilos inline, fija el estado final y LIBERA el flag
        // animating. Lo dispara el transitionend de `height` O un fallback por tiempo — así el
        // flag nunca se queda colgado (si el transitionend no llega, el grupo no se podía reabrir).
        var done = false;
        var fallback;
        function finish() {
          if (done) return;
          done = true;
          clearTimeout(fallback);
          content.removeEventListener('transitionend', onEnd);
          if (!willOpen) details.removeAttribute('open');
          content.style.height = '';
          content.style.marginTop = '';
          content.style.overflow = '';
          content.style.maxHeight = ''; // restaura el cap del CSS (scroll) tras animar
          details.dataset.animating = 'false';
        }
        function onEnd(ev) {
          // Solo el fin de la transición de ALTURA del propio content (ignora margin-top y los
          // transitionend que burbujeen desde hijos, p.ej. hover de un checkbox).
          if (ev.target === content && ev.propertyName === 'height') finish();
        }
        content.addEventListener('transitionend', onEnd);
        fallback = window.setTimeout(finish, 400); // > 280ms de la transición

        if (willOpen) {
          // OPEN: 0 → altura visible (topada al max-height)
          details.setAttribute('open', '');
          var targetH = animTargetHeight(content); // con el max-height del CSS aún activo → tope real
          content.style.maxHeight = 'none';         // liberar el max-height: rompe la transición de height
          content.style.height = '0px';
          content.style.marginTop = '0px';
          content.style.overflow = 'hidden';
          content.offsetHeight; // eslint-disable-line no-unused-expressions
          requestAnimationFrame(function () {
            content.style.height = targetH + 'px';
            content.style.marginTop = '';
          });
        } else {
          // CLOSE: altura visible (topada al max-height) → 0
          var startH = animTargetHeight(content);
          content.style.maxHeight = 'none';
          content.style.height = startH + 'px';
          content.style.overflow = 'hidden';
          content.offsetHeight; // eslint-disable-line no-unused-expressions
          requestAnimationFrame(function () {
            content.style.height = '0px';
            content.style.marginTop = '0px';
          });
        }
      }

      host.addEventListener('click', onClick);
      this._addCleanup(function () {
        host.removeEventListener('click', onClick);
      });
    }
  }

  customElements.define('bs-collection-grid', BsCollectionGrid);
})();
